export const isValidBase64 = (str: string): boolean => {
  try {
    atob(str);
    return true;
  } catch (e) {
    return false;
  }
};
